'use strict';

// import $ from 'jquery';

import config from '../../../model/Config';
import model from '../../../model/Model';
import browseDevice from '../../utils/BrowseDevice';

namespace ViewModelCore {
	export class PageCore {
		// public mq: String = 'PC';
		public $window = $(window);
		public $body = $('body');
		public fixMq: string = '';
		public tempMq: string = '';

		private mq_tb: number = config.MQ_TB;
		private mq_sp: number = config.MQ_SP;

		private mode_pc: string = config.MODE_PC;
		private mode_tb: string = config.MODE_TB;
		private mode_sp: string = config.MODE_SP;


		constructor() {
			model.data.isMobile = !browseDevice.judgeBrowse().isPc ? true : false;
		}

		public onInit(): void {
			if (model.data.isMobile) this.$body.addClass('isMobileOS');
			if(navigator.platform.indexOf("Win") != -1 && !model.data.isMobile) $('body').addClass('isOSWindows');
			this.onResize();
			this.$window.on('resize', () => {
				this.onResize();
			});
		}

		public onResize(): void {
			this.onMqCHANGE();
		}

		public onMqCHANGE() {
			let dw: any = window.innerWidth;
			let dh: any = window.innerHeight;
			if (dw === undefined || dw === 'undefined') {
				dw = this.$window.width();
			}

			if(dw > dh){
				$('html').addClass('landscape')
			} else {
				$('html').removeClass('landscape')
			}

			if (dw <= this.mq_sp) {
				this.fixMq = this.mode_sp;
			} else if (dw > this.mq_sp && dw <= this.mq_tb) {
				this.fixMq = this.mode_tb;
			} else {
				this.fixMq = this.mode_pc;
			}

			if (this.fixMq !== this.tempMq) {
				//Model更新(mode);
				model.data.modelMq = this.fixMq;
				//レスポンシブ画像切り替え
				this.tempMq = this.fixMq;
			}
		}
	}
}

export default ViewModelCore;
